import { render, staticRenderFns } from "./IosAndroidApp.vue?vue&type=template&id=776e4c0e&"
import script from "./IosAndroidApp.vue?vue&type=script&lang=js&"
export * from "./IosAndroidApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports